module.exports = __webpack_public_path__ + "static/media/jetson_one_render_05.ddb56052.jpg";